import controller from './kform-element.controller';
import template from './kform-element.html';
import './kform-element.scss';

const kformElementComponent = {
	bindings: {
		component: '<',
		data:      '<ngModel',
		index:     '<',
		readOnly:  '<',
	},
	require:  {
		ngModelCtrl:              'ngModel',
		kformComponentController: '^kformComponent',
	},
	controller,
	// template: '<ng-transclude></ng-transclude>',
	template,
	transclude: true,
};

export default kformElementComponent;
